import React from 'react';
import RegisterForm from '../Components/Layout/RegisterForm';
import SectionLabel from '../Components/Common/SectionLabel';
import './Booking.css'
import StaggeredMenu from '../Components/Layout/StaggeredMenu';
import Footer from '../Components/Layout/Footer';
import BookingAnim from '../Components/Layout/BookingAnim';

import Ticket from '../Assets/Imgs/TicketTemplate.png'


const Booking = () => {

    const items = [
    <img src={Ticket} alt="" />,
    <img src={Ticket} alt="" />,
    <img src={Ticket} alt="" />,
    <img src={Ticket} alt="" />,
    <img src={Ticket} alt="" />,
    <img src={Ticket} alt="" />,
    <img src={Ticket} alt="" />,
    <img src={Ticket} alt="" />,
    <img src={Ticket} alt="" />,
    <img src={Ticket} alt="" />,
    <img src={Ticket} alt="" />,
    <img src={Ticket} alt="" />,
    // Add more items as needed
    ];

    const menuItems = [
        { label: 'Home', ariaLabel: 'Go to home page', link: '/' },
        { label: 'Booking', ariaLabel: 'Book your visit', link: '/booking' },
        { label: 'Gallery', ariaLabel: 'Take a peek at our past events', link: '/gallery' }
      ];

    return ( <>

            <StaggeredMenu
                        position="right"
                        items={menuItems}
                        displaySocials
                        displayItemNumbering={true}
                        menuButtonColor="#3A3A3A"
                        openMenuButtonColor="#3A3A3A"
                        changeMenuColorOnOpen={true}
                        colors={['#35A44F', '#21FF55']}
                        logoUrl='../Assets/Imgs/Logo.svg'
                        accentColor="#35A44F"
                        onMenuOpen={() => console.log('Menu opened')}
                        onMenuClose={() => console.log('Menu closed')}
                    />

            <section className='RegisterForm'>
                <div className='RegisterContent'>
                    <RegisterForm />
                </div>
                <div className='FormText'>
                    <SectionLabel SectionLabel="Register / 06"/>
                    <p className='SectionTitle'>Book Your Visit</p>

                    <div className='TicketsAnim'>
                        <BookingAnim items={items}
                        gradientColor="white"
                        />
                    </div>

                    
                </div>
            </section>

            <Footer />
    </> );
}
 
export default Booking;